// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"81b55a70","453":"dc5e1244"}[chunkId] + ".chunk.js";
};